import "vant/es/empty/style";
import _Empty from "vant/es/empty";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/*
 * @Description: 客户资料库模块路由（自 crisps-production-mobile-h5 项目迁移，前缀 /customer-library）
 * 注：本文件为新引入模块的装配点——van-empty 组件注册与模块公共样式引入均在此完成，
 * 不改动 scrm 原有 plugins/vant.js 与 main.js
 */
import Vue from 'vue';
import '@/assets/css/customer-library.scss';
Vue.use(_Empty);
var routers = [{
  // :customerId? 可选动态参数：外部调用可从 path 传入（如 /customer-library/index/3963083817140003296），
  // 不带参数时也匹配原地址；页面内兼容 query 传入，均无则用页面内默认值联调
  path: '/customer-library/index/:customerId?',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/index.vue');
  },
  meta: {
    title: '客户资料库',
    // 首页缓存：从二级页返回时保留 Tab 状态/列表数据/滚动位置
    keepAlive: true
  }
}, {
  path: '/customer-library/company-detail',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/company-detail.vue');
  },
  meta: {
    title: '公司详情',
    // 缓存：从宫格列表页返回保持原状；公司条目变化由 activated/watch 检测 query.company 重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/trademark-list',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/trademark-list.vue');
  },
  meta: {
    title: '商标列表',
    // 列表缓存：从详情页返回保留列表数据/分页状态，不重新请求；换客户再进由 activated 检测重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/trademark-detail',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/trademark-detail.vue');
  },
  meta: {
    title: '商标详情',
    keepAlive: false
  }
}, {
  path: '/customer-library/patent-list',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/patent-list.vue');
  },
  meta: {
    title: '专利列表',
    // 列表缓存：从详情页返回保留列表数据/分页状态，不重新请求；换客户再进由 activated 检测重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/patent-detail',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/patent-detail.vue');
  },
  meta: {
    title: '专利详情',
    keepAlive: false
  }
}, {
  path: '/customer-library/copyright-list',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/copyright-list.vue');
  },
  meta: {
    title: '版权列表',
    // 列表缓存：从详情页返回保留列表数据/分页状态，不重新请求；换客户再进由 activated 检测重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/copyright-detail',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/copyright-detail.vue');
  },
  meta: {
    title: '著作权详情',
    keepAlive: false
  }
}, {
  path: '/customer-library/official-docs',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/official-docs.vue');
  },
  meta: {
    title: '官文与证书',
    // 列表缓存：从详情页返回保留三 tab 数据/页签位置，不重新请求；换客户再进由 activated 检测重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/annual-fees',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/annual-fees.vue');
  },
  meta: {
    title: '年费管理',
    // 缓存：数据不依赖路由参数（接口全局mock），重复进入保持原状不重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/business-info',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/business-info.vue');
  },
  meta: {
    title: '工商信息',
    // 缓存：数据不依赖路由参数（接口全局mock），重复进入保持原状不重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/qualifications',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/qualifications.vue');
  },
  meta: {
    title: '资质证书',
    // 缓存：数据不依赖路由参数（接口全局mock），重复进入保持原状不重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/tech-projects',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/tech-projects.vue');
  },
  meta: {
    title: '科技项目',
    // 缓存：数据不依赖路由参数（接口全局mock），重复进入保持原状不重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/confirmation-sheets',
  component: function component() {
    return import(/* webpackChunkName: "customerLibrary" */'@/views/customer-library/confirmation-sheets.vue');
  },
  meta: {
    title: '业务底单',
    // 缓存：数据不依赖路由参数（接口全局mock），重复进入保持原状不重拉
    keepAlive: true
  }
}, {
  path: '/customer-library/oss-uploader',
  component: function component() {
    return import('@/views/customer-library/oss-uploader/index.vue');
  },
  meta: {
    title: 'oss上传',
    keepAlive: false
  }
}, {
  path: '/PdfViewer',
  component: function component() {
    return import('@/components/PdfViewer');
  },
  meta: {
    title: 'PDF预览',
    keepAlive: false
  }
}];
export default routers;